
export default function KaysvilleTrust() {
  const trustFactors = [
    {
      icon: 'ri-time-line',
      title: 'Rapid Response in Kaysville',
      description: 'We arrive within 60 minutes to any location in Kaysville, from Barnes Park to Cherry Hill and Mutton Hollow.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Certified Professionals',
      description: 'IICRC-certified water damage restoration specialists with years of experience serving Kaysville residents.'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Local Kaysville Experts',
      description: 'We know Kaysville inside and out - from downtown to Kaysville Heights and all surrounding neighborhoods.'
    }
  ];

  return (
    <section className="py-10 md:py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8">
          {trustFactors.map((factor, index) => (
            <div key={index} className="bg-white rounded-xl p-5 md:p-8 shadow-sm hover:shadow-md transition-shadow">
              <div className="w-12 h-12 md:w-16 md:h-16 bg-sky-100 rounded-full flex items-center justify-center mb-4 md:mb-6">
                <i className={`${factor.icon} text-2xl md:text-3xl text-sky-600`}></i>
              </div>
              <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-2 md:mb-3">{factor.title}</h3>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed">{factor.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
